import Loading from "../../../components/Loading"
import Card from "../../../components/Card"
interface Prop {
  Insights: any,
  isMobile?: boolean | undefined
}
const IndustryInsightsComponent = ({ Insights, isMobile }: Prop) => {
  return (
    <div className="pt-5 mb-10">
      <div className="row">
        <div className="col-12 col-lg-12 col-md-12">
          <h3 className="fs-1 fw-bolder">INDUSTRY INSIGHTS</h3>
          <div className="row g-3">
            {Insights?.length > 0 ? (
              <>
                <Card
                  class="col-12 col-lg-4"
                  bgColor="bg-primary"
                  titleTextColor="text-secondary fs-3"
                  subtitleTextColor="text-white"
                  bodyClass="text-white text-truncate-two"
                  title={Insights[0].title.rendered}
                  date={new Date(Insights[0].date).toDateString().split(' ').slice(1).join(' ')}
                  author={" • " + Insights[0]._embedded.author[0].name}
                  body={Insights[0].content.rendered.substring(0, 122)}
                  link={"/insights/article/" + Insights[0].slug}
                />
                {Insights.slice(1, 3).map((insight: any, index: number) => (
                  <Card
                    key={"insight" + index}
                    class="col-12 col-lg-4 col-sm-12"
                    bgColor="bg-white"
                    titleTextColor="text-primary fs-3"
                    subtitleTextColor="text-grey-700"
                    bodyClass="text-truncate-two"
                    title={insight.title.rendered}
                    date={new Date(insight.date).toDateString().split(' ').slice(1).join(' ')}
                    author={" • " + insight._embedded.author[0].name}
                    body={insight.content.rendered.substring(0, 122)}
                    link={"/insights/article/" + insight.slug}
                  />
                ))}
              </>
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default IndustryInsightsComponent;